import { connect } from 'react-redux';
import Commitments from './components/Commitments';

const mapStateToProps = (state) => ({
  agencyId: state.auth.profile.extend.agency.id
});

export default connect(mapStateToProps)(Commitments);
